// 导出页面为PDF格式
// import html2Canvas from 'html2canvas'
import '@/assets/js/html2canvas.js';
import JsPDF from 'jspdf';
// import { dataURLtoFile } from './imageHelper'
import axios from 'axios';
const A4_WIDTH = 592.28;
const A4_HEIGHT = 841.89;

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function(pdfDom, vtitle, _this, option) {
      return new Promise(async(resolve, reject) => {
        //  console.log(html2canvas)
        // html2Canvas
        _this.$Spin.show();
        // 当下载pdf时，若不在页面顶部会造成PDF样式不对,所以先回到页面顶部再下载

        var element = document.getElementById(pdfDom);
        if (element != null) {
          element.scrollIntoView();
          //  element = null
        }
        const title = vtitle;
        const contentWidth = 841.89; //  [param.contentWidth=550] - 一页pdf的内容宽度，0-592.28
        var tableWidth = document.querySelector('table').scrollWidth;
        document.querySelector(`#${pdfDom}`).style.width =
          tableWidth * 1.05 + 'px';
        html2canvas(document.querySelector(`#${pdfDom}`), {
          allowTaint: true,
          dpi: 350,
          // scale: window.devicePixelRatio * 2, // 增加清晰度
          background: '#ffffff',
          onrendered: async function(canvas) {
            // 获取canvas画布的宽高
            var context = canvas.getContext('2d');
            // 获取canavs转化后的宽度
            const canvasWidth = canvas.width;
            // 获取canvas转化后的高度
            const canvasHeight = canvas.height;
            const width = 841.89;
            // 高度转化为PDF的高度

            const height = (width / canvasWidth) * canvasHeight;
            // 转化成图片Data
            const canvasData = canvas.toDataURL('image/jpeg', 1.0);
            const copyCanvasData = canvasData;
            //  console.log(canvasData)
            // 页面偏移
            const position = 0;
            // html页面生成的canvas在pdf中图片的宽高（本例为：横向a4纸[841.89,592.28]，纵向需调换尺寸）
            // 第一个参数： l：横向  p：纵向
            // 第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）；
            // 第三个参数：可以是下面格式，默认为“a4”。如需自定义格式，只需将大小作为数字数组传递，如：[592.28, 841.89];
            //        a0 - a10
            //        b0 - b10
            //        c0 - c10
            //          dl
            //        letter
            //        government-letter
            //        legal
            //        junior-legal
            //        ledger
            //        tabloid
            //        credit-card

            //  const pageData = canvas.toDataURL('image/jpeg', 1.0)
            const PDF = new JsPDF('l', 'pt', 'a4');
            // 两个高度需要区分: 一个是html页面的实际高度，和生成pdf的页面高度
            // 当内容未超过pdf一页显示的范围，无需分页
            // 距离PDF左边的距离，/ 2 表示居中
            const baseX = 0; // 预留空间给左边
            // 距离PDF 页眉和页脚的间距， 留白留空
            const baseY = 0;
            // 出去页头、页眉、还有内容与两者之间的间距后 每页内容的实际高度
            const originalPageHeight = A4_HEIGHT - 2 * baseY;
            // 元素在网页页面的宽度
            const elementWidth = element.offsetWidth;
            // 每一页的分页坐标， PDF高度， 初始值为根元素距离顶部的距离
            // PDF内容宽度 和 在HTML中宽度 的比， 用于将 元素在网页的高度 转化为 PDF内容内的高度， 将 元素距离网页顶部的高度  转化为 距离Canvas顶部的高度
            // const rate = contentWidth / elementWidth
            const rate = contentWidth / elementWidth;
            // rate * getElementTop(element)
            const pages = [];
            // 深度遍历节点的方法
            traversingNodes(element.childNodes);
            // PDF.addImage(canvasData, 'JPEG', 0, 0, width, height)

            // PDF.save(title + '.pdf')

            // 根据分页位置 开始分页
            for (let i = 0; i < pages.length; ++i) {
              // 根据分页位置新增图片
              addImage(
                baseX,
                -(pages[i] - pages[0]),
                PDF,
                canvasData,
                width,
                height
              );
              // // 对于除最后一页外，对 内容 的多余部分进行遮白处理
              if (i < pages.length - 1) {
                // 获取当前页面需要的内容部分高度
                const imageHeight = pages[i + 1] - pages[i];
                // 对多余的内容部分进行遮白
                addBlank(0, imageHeight, width, height - imageHeight, PDF);
              }
              // 若不是最后一页，则分页
              if (i !== pages.length - 1) {
                // 增加分页
                PDF.addPage();
              }
            }
            PDF.save(title + '.pdf');
            _this.$Spin.hide();
            try {
              const { uploadToken, UploadUrl, downloadUrl } = await getUploadtoken(
                _this
              );

              // dataURLtoFile(copyCanvasData, title),
              if ((_this.tableType == 2 || _this.tableType == 1) && !option) {
                const { fileName, fileId } = await uploadPdf(
                  dataURLtoFile(PDF.output('dataurlstring'), title),
                  uploadToken,
                  UploadUrl
                );
                resolve({ fileName, fileId });
              }
              resolve();
            } catch (err) {
              reject(err);
            }

            // 增加空白遮挡
            function addBlank(x, y, width, height, pdf) {
              PDF.setFillColor(255, 255, 255);
              PDF.rect(x, y, Math.ceil(width), Math.ceil(height), 'F');
            }
            // 获取元素距离网页顶部的距离
            // 通过遍历offsetParant获取距离顶端元素的高度值
            function getElementTop(element) {
              let actualTop = element.offsetTop;
              let current = element.offsetParent;

              while (current && current !== null) {
                actualTop += current.offsetTop;
                current = current.offsetParent;
              }
              return actualTop;
            }
            // 可能跨页元素位置更新的方法
            // 需要考虑分页元素，则需要考虑两种情况
            // 1. 普通达顶情况，如上
            // 2. 当前距离顶部高度加上元素自身高度 大于 整页高度，则需要载入一个分页点
            function updatePos(eheight, top) {
              pages.push(top);
            }
            // 添加
            function addImage(_x, _y, pdf, data, width, height) {
              PDF.addImage(data, 'JPEG', _x, _y, width, height);
            }

            // 遍历正常的元素节点
            function traversingNodes(nodes) {
              for (let i = 0; i < nodes.length; ++i) {
                const one = nodes[i];
                // 需要判断跨页且内部存在跨页的元素
                const isDivideInside =
                  one.classList &&
                  one.classList.contains('settlement-download-details');

                const { offsetHeight } = one;
                // 计算出最终高度
                const offsetTop = getElementTop(one);
                // dom转换后距离顶部的高度
                // 转换成canvas高度
                const top = rate * offsetTop;
                console.log(offsetTop, top, rate);
                // 对于需要进行分页且内部存在需要分页（即不属于深度终点）的元素进行处理
                if (isDivideInside) {
                  // 执行位置更新操作
                  updatePos(rate * offsetHeight, top, one);
                }
              }
              return;
            }
          }
        });
      });
    };
  }
};

// 上传token
function getUploadtoken(_this) {
  return new Promise((resolve, reject) => {
    _this.$http.getUploadtoken().then((res) => {
      const uploadToken = res.message.token;
      const UploadUrl = res.message.upUrl;
      const downloadUrl = res.message.downUrl;
      resolve({ uploadToken, UploadUrl, downloadUrl });
    });
  });
}
function dataURLtoFile(dataurl, title) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  const file = new File([u8arr], `${title}.pdf`, { type: mime });
  return file;
}

// 上传图片
function uploadPdf(ev, uploadToken, UploadUrl) {
  return new Promise(async(resolve, reject) => {
    const file = ev;
    const formData = new FormData();
    formData.append('token', uploadToken);
    formData.append('file', file);
    const token = localStorage.getItem('loginToken');
    const source = axios.CancelToken.source();
    var configs = {
      // 上传文件 请求头要设置成下面这样
      headers: {
        token: token,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      cancelToken: source.token
    };

    axios
      .post(UploadUrl, formData, configs)
      .then((res) => {
        if (res.data.status === 200) {
          // const id = res.data.message.fileId

          resolve({
            fileId: res.data.message.fileId,
            fileName: res.data.message.name
          });
        } else {
          reject(res.data.error);
        }
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {});
  });
}
